import { Select } from 'antd';

export { default as Select } from './Select';
export { default as SelectInsert } from './SelectInsert';
export const { Option } = Select;
